import { render } from "./ContactBox.vue?vue&type=template&id=41cce5f0&scoped=true"
import script from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=41cce5f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cce5f0"]])

export default __exports__